import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import { Form, FormActions } from 'components/form';
import ActionButton from 'components/buttons/action-button/ActionButton';
import ProfileFormFieldsAboutWork from './form/about-work/ProfileFormFieldsAboutWork';

import type { InfluencerProfileForm } from 'types';
import type { FieldDescriptionShowParams } from '../influencer-create-profile/InfluencerCreateProfile';

applyTranslations(require('./i18n/profile-creation-common.i18n.json'));

type Props = {
  details: InfluencerProfileForm,
  onSubmit: (a: InfluencerProfileForm) => void,
  onCancel: (a: InfluencerProfileForm) => void,
  onFieldDescriptionShow: (p: FieldDescriptionShowParams) => void,
  onFieldDescriptionHide: () => void
};

type State = {
  details: InfluencerProfileForm
};

class ProfileCreationStepAboutWork extends React.PureComponent<Props, State> {
  state = {
    details: {
      ...this.props.details
    }
  };

  handleDetailsChanged = (details: InfluencerProfileForm): void => {
    this.setState(state => ({
      details: {
        ...state.details,
        ...details
      }
    }));
  };

  handleSpecializedInChanged = (specializedInCustom: Array<string>) => {
    this.setState(state => ({
      details: {
        ...state.details,
        specializedIn: {
          ...state.details.specializedIn,
          custom: specializedInCustom
        }
      }
    }));
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { details } = this.state;

    onSubmit(details);
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    const { details } = this.state;

    onCancel(details);
  };

  render() {
    const { onFieldDescriptionShow, onFieldDescriptionHide } = this.props;
    const { details } = this.state;
    const specializedIn = details ? details.specializedIn : {};

    return (
      <section data-qa="profile-creation-step-about-work">
        <Form
          onSubmit={this.handleSubmit}
        >
          <ProfileFormFieldsAboutWork
            details={details}
            specializedIn={specializedIn}
            onDetailsChange={this.handleDetailsChanged}
            onSpecializedInChange={this.handleSpecializedInChanged}
            onFieldDescriptionShow={onFieldDescriptionShow}
            onFieldDescriptionHide={onFieldDescriptionHide}
          />
          <div className="influencer-create-profile__form-container">
            <FormActions
              containerClass="influencer-create-profile__form-container-inner-block"
              align="center"
            >
              <ActionButton
                color="tertiary"
                onClick={this.handleCancel}
              >
                {__t('profile_creation_common.buttons.button_back')}
              </ActionButton>
              <ActionButton
                color="primary"
                type="submit"
              >
                {__t('profile_creation_common.buttons.button_continue')}
              </ActionButton>
            </FormActions>
          </div>
        </Form>
      </section>
    );
  }
}

export default ProfileCreationStepAboutWork;
